import React, {
  useCallback,
  useEffect,
} from 'react';
import './Theme.css';

const THEMES = [
  { cl: 'dark-default', color: '#2f353beb' },
  { cl: 'dark-green', color: '#303b2fd4' },
  { cl: 'dark-red', color: '#3b2f34d4' },
  { cl: 'dark-blue', color: '#2f303bd4' },
  { cl: 'dark-brown', color: '#3b332fd4' },
];

const Theme = (props = { id: 0 }) => {
  const THEME_KEY = `cb-theme-${props.id}`;
  const DARK_MODE = 'dark-mode';

  const themeSwitch = useCallback((className = '') => {
    const cl = document.body.classList;

    if (className) {
      cl.remove(...THEMES.map(v => v.cl));
      cl.add(DARK_MODE);
      cl.add(className);
      localStorage.setItem(THEME_KEY, className);
    } else if (cl.contains(DARK_MODE)) {
      cl.remove(DARK_MODE);
      localStorage.setItem(THEME_KEY, '');
    } else {
      cl.add(DARK_MODE);
      localStorage.setItem(THEME_KEY, DARK_MODE);
    }
  }, [THEME_KEY]);

  const checkTheme = useCallback(() => {
    const theme = localStorage.getItem(THEME_KEY);
    if (theme && THEMES.map(v => v.cl).includes(theme)) {
      themeSwitch(theme);
    } else if (theme === DARK_MODE) {
      themeSwitch();
    }
  }, [themeSwitch, THEME_KEY]);

  useEffect(() => {
    checkTheme();
  }, [checkTheme]);

  return (
    <span className="btn-wrapper theme-wrapper">
      <button className="btn btn-default" data-e2e-id="btn-theme"
        onClick={() => themeSwitch()}>
        <i className={'fa fa-adjust'}/>
      </button>
      <ul className="color-pallet fade-in-up">
        {THEMES.map((v, i) => (
          <li key={i}
            data-e2e-id={`btn-theme-${i}`}
            style={{'background': v.color}}
            onClick={() => themeSwitch(v.cl)}
          />
        ))}
      </ul>
    </span>
  );
};

export default Theme;
